import Vue from 'vue';
import moment from 'moment';


// 日時整形
Vue.filter('dtf', (value: string, format: string = 'YYYY/MM/DD HH:mm:ss'): string => {
  if (value === undefined || value === null) return '';
  return moment(value, 'YYYY-MM-DD HH:mm:ss').format(format);
});

// 秒から"分:秒"へ変換
Vue.filter('msf', (value: number): string => {
  if (value === undefined || value === null) return '';
  const min = Math.floor(value / 60);
  const sec = value % 60;
  return ((min < 10) ? '0' : '') + min + ':' + ((sec < 10) ? '0' : '') + sec;
});

// 誕生日整形（引数がYYYYMMDD形式以外の場合があるので、dtfとは別実装）
Vue.filter('birthday', (value: string): string => {
  if (value === undefined || value === null) return '';
  if (value.length === 8) return value.substring(0, 4) + '/' + value.substring(4, 6) + '/' + value.substring(6);
  return value;
});
